import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Sass = () => {
  return (
    <StartInterviewLayout type="sass"/>
  )
}

export default Sass;